// Calculator categories for organized navigation
export const calculatorCategories = [
  {
    id: "manufacturing",
    label: "Manufacturing",
    children: [
      {
        id: "machining",
        label: "Machining",
        children: [
          {
            id: "corner-distance",
            label: "Corner Distance",
            path: "/cornerdistance",
          },
          {
            id: "counter-sink-depth",
            label: "Counter Sink Depth",
            path: "/countersink-depth",
          },
          {
            id: "cutting-speed",
            label: "Cutting Speed",
            path: "/cuttingspeed",
          },
          {
            id: "rigid-tapping",
            label: "Rigid Tapping",
            path: "/rigidtapping",
          },
          {
            id: "strip-width",
            label: "Strip Width Calculator",
            path: "/strip-width-calculator",
          },
          {
            id: "feeds-speeds-chip",
            label: "Feeds & Speeds with Chip Thinning",
            path: "/feeds-speeds-chip-thinning",
          },
          {
            id: "milling",
            label: "Milling Calculator",
            path: "/milling-calculator",
          },
          {
            id: "turning",
            label: "Turning Calculator",
            path: "/turning-calculator",
          },
          {
            id: "drilling",
            label: "Drilling Calculator",
            path: "/drilling-calculator",
          },
          {
            id: "k-factor-calculator",
            label: "Press Brake Bending K-Factors",
            path: "/k-factor-calculator",
          },
          {
            id: "cutting-edge-diameter",
            label: "Cutting Edge Circumscribed Circle",
            path: "/cutting-edge-diameter-calculator",
          },
        ],
      },
      {
        id: "quality-control",
        label: "Quality Control",
        children: [
          {
            id: "tolerance-stack",
            label: "Tolerance Stack Analysis",
            path: "/tolerance-stack",
            hidden: true,
          },
          {
            id: "gauge-rr",
            label: "Gauge R&R Calculator",
            path: "/gauge-rr",
            hidden: true,
          },
          {
            id: "cpk-calculator",
            label: "Cpk Calculator",
            path: "/cpk-calculator",
            hidden: true,
          },
        ],
      },
      {
        id: "production-planning",
        label: "Production Planning",
        children: [
          {
            id: "cycle-time",
            label: "Cycle Time Calculator",
            path: "/cycle-time",
            hidden: true,
          },
          {
            id: "oee-calculator",
            label: "OEE Calculator",
            path: "/oee-calculator",
            hidden: true,
          },
          {
            id: "capacity-planning",
            label: "Capacity Planning",
            path: "/capacity-planning",
            hidden: true,
          },
        ],
      },
    ],
  },
  {
    id: "business",
    label: "Business",
    children: [
      {
        id: "finance",
        label: "Finance",
        children: [
          {
            id: "business-loan",
            label: "Business Loan Calculator",
            path: "/business-loan-calculator",
          },
          {
            id: "roi-calculator",
            label: "ROI Calculator",
            path: "/roi-calculator",
            hidden: true,
          },
          {
            id: "payback-period",
            label: "Payback Period",
            path: "/payback-period",
            hidden: true,
          },
          {
            id: "npv-calculator",
            label: "NPV Calculator",
            path: "/npv-calculator",
            hidden: true,
          },
          {
            id: "irr-calculator",
            label: "IRR Calculator",
            path: "/irr-calculator",
            hidden: true,
          },
        ],
      },
      {
        id: "marketing",
        label: "Marketing",
        children: [
          {
            id: "cac-calculator",
            label: "Customer Acquisition Cost",
            path: "/cac-calculator",
            hidden: true,
          },
          {
            id: "ltv-calculator",
            label: "Customer Lifetime Value",
            path: "/ltv-calculator",
            hidden: true,
          },
          {
            id: "conversion-rate",
            label: "Conversion Rate Calculator",
            path: "/conversion-rate",
            hidden: true,
          },
          {
            id: "cpm-calculator",
            label: "CPM Calculator",
            path: "/cpm-calculator",
            hidden: true,
          },
        ],
      },
      {
        id: "hr",
        label: "Human Resources",
        children: [
          {
            id: "timesheet-calculator",
            label: "Timesheet Calculator",
            path: "/timesheet-calculator",
          },
        ],
      },
    ],
  },
  {
    id: "tools",
    label: "Tools",
    children: [
      {
        id: "scanning",
        label: "Scanning & Codes",
        children: [
          {
            id: "qr-inspector",
            label: "QR Code and Barcode Inspector",
            path: "/qr-inspector",
          },
          {
            id: "barcode-generator",
            label: "Barcode Generator",
            path: "/barcode-generator",
            hidden: true,
          },
        ],
      },
      {
        id: "social-media",
        label: "Social Media",
        children: [
          {
            id: "bold-unicode",
            label: "Bold Unicode Text",
            path: "/bold-unicode",
          },
          {
            id: "hashtag-generator",
            label: "Hashtag Generator",
            path: "/hashtag-generator",
            hidden: true,
          },
          {
            id: "social-scheduler",
            label: "Social Media Scheduler",
            path: "/social-scheduler",
            hidden: true,
          },
        ],
      },
      {
        id: "utilities",
        label: "Utilities",
        children: [
          {
            id: "unit-converter",
            label: "Unit Converter",
            path: "/unit-converter",
            hidden: true,
          },
          {
            id: "color-picker",
            label: "Color Picker",
            path: "/color-picker",
            hidden: true,
          },
          {
            id: "password-generator",
            label: "Password Generator",
            path: "/password-generator",
            hidden: true,
          },
        ],
      },
    ],
  },
];

// Legacy flat array for backward compatibility
export const calculatorOptions = [
  { value: "/addition", label: "Addition" },
  { value: "/countersink-depth", label: "Counter Sink Depth" },
  { value: "/cuttingspeed", label: "Speed and Feeds" },
  { value: "/rigidtapping", label: "Rigid Tapping Feed" },
  { value: "/cornerdistance", label: "Distance across corners" },
];
